import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/WaitFor',
      name: 'WaitFor',
      component: () => import('@/views/waitFor'),
      meta: {
        title: '待审批'
      }
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('@/views/detail'),
      meta: {
        title: '申请详情'
      }
    }
  ]
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js